import { render, staticRenderFns } from "./SkillGap.vue?vue&type=template&id=e8ba2d24&scoped=true"
import script from "./SkillGap.vue?vue&type=script&lang=ts"
export * from "./SkillGap.vue?vue&type=script&lang=ts"
import style0 from "./SkillGap.vue?vue&type=style&index=0&id=e8ba2d24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ba2d24",
  null
  
)

export default component.exports